import VKSansText_Regular_woff2_namespaceObject from "../../static/font/VKSansText-Regular.woff2";
export default VKSansText_Regular_woff2_namespaceObject;
